function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableselection
 */
import { Plugin } from 'ckeditor5/src/core';
import { first } from 'ckeditor5/src/utils';
import TableWalker from './tablewalker';
import TableUtils from './tableutils';
import { cropTableToDimensions, adjustLastRowIndex, adjustLastColumnIndex } from './utils/structure';
import { getColumnIndexes, getRowIndexes, getSelectedTableCells as _getSelectedTableCells, isSelectionRectangular } from './utils/selection';
import '../theme/tableselection.css';
/**
 * This plugin enables the advanced table cells, rows and columns selection.
 * It is loaded automatically by the {@link module:table/table~Table} plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TableSelection = /*#__PURE__*/function (_Plugin) {
  _inherits(TableSelection, _Plugin);

  var _super = _createSuper(TableSelection);

  function TableSelection() {
    _classCallCheck(this, TableSelection);

    return _super.apply(this, arguments);
  }

  _createClass(TableSelection, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var model = editor.model;
      this.listenTo(model, 'deleteContent', function (evt, args) {
        return _this._handleDeleteContent(evt, args);
      }, {
        priority: 'high'
      });

      this._defineSelectionConverter();

      this._enablePluginDisabling(); // sic!

    }
    /**
     * Returns the currently selected table cells or `null` if it is not a table cells selection.
     *
     * @returns {Array.<module:engine/model/element~Element>|null}
     */

  }, {
    key: "getSelectedTableCells",
    value: function getSelectedTableCells() {
      var selection = this.editor.model.document.selection;

      var selectedCells = _getSelectedTableCells(selection);

      if (selectedCells.length == 0) {
        return null;
      } // This should never happen, but let's know if it ever happens.
      // @if CK_DEBUG //	/* istanbul ignore next */
      // @if CK_DEBUG //	if ( selectedCells.length != selection.rangeCount ) {
      // @if CK_DEBUG //		console.warn( 'Mixed selection warning. The selection contains table cells and some other ranges.' );
      // @if CK_DEBUG //	}


      return selectedCells;
    }
    /**
     * Returns the selected table fragment as a document fragment.
     *
     * @returns {module:engine/model/documentfragment~DocumentFragment|null}
     */

  }, {
    key: "getSelectionAsFragment",
    value: function getSelectionAsFragment() {
      var _this2 = this;

      var selectedCells = this.getSelectedTableCells();

      if (!selectedCells) {
        return null;
      }

      return this.editor.model.change(function (writer) {
        var documentFragment = writer.createDocumentFragment();

        var tableUtils = _this2.editor.plugins.get('TableUtils');

        var _getColumnIndexes = getColumnIndexes(selectedCells),
            firstColumn = _getColumnIndexes.first,
            lastColumn = _getColumnIndexes.last;

        var _getRowIndexes = getRowIndexes(selectedCells),
            firstRow = _getRowIndexes.first,
            lastRow = _getRowIndexes.last;

        var sourceTable = selectedCells[0].findAncestor('table');
        var adjustedLastRow = lastRow;
        var adjustedLastColumn = lastColumn; // If the selection is rectangular there could be a case of all cells in the last row/column spanned over
        // next row/column so the real lastRow/lastColumn should be updated.

        if (isSelectionRectangular(selectedCells, tableUtils)) {
          var dimensions = {
            firstColumn: firstColumn,
            lastColumn: lastColumn,
            firstRow: firstRow,
            lastRow: lastRow
          };
          adjustedLastRow = adjustLastRowIndex(sourceTable, dimensions);
          adjustedLastColumn = adjustLastColumnIndex(sourceTable, dimensions);
        }

        var cropDimensions = {
          startRow: firstRow,
          startColumn: firstColumn,
          endRow: adjustedLastRow,
          endColumn: adjustedLastColumn
        };
        var table = cropTableToDimensions(sourceTable, cropDimensions, writer);
        writer.insert(table, documentFragment, 0);
        return documentFragment;
      });
    }
    /**
     * Sets the model selection based on given anchor and target cells (can be the same cell).
     * Takes care of setting the backward flag.
     *
     *		const modelRoot = editor.model.document.getRoot();
     *		const firstCell = modelRoot.getNodeByPath( [ 0, 0, 0 ] );
     *		const lastCell = modelRoot.getNodeByPath( [ 0, 0, 1 ] );
     *
     *		const tableSelection = editor.plugins.get( 'TableSelection' );
     *		tableSelection.setCellSelection( firstCell, lastCell );
     *
     * @param {module:engine/model/element~Element} anchorCell
     * @param {module:engine/model/element~Element} targetCell
     */

  }, {
    key: "setCellSelection",
    value: function setCellSelection(anchorCell, targetCell) {
      var cellsToSelect = this._getCellsToSelect(anchorCell, targetCell);

      this.editor.model.change(function (writer) {
        writer.setSelection(cellsToSelect.cells.map(function (cell) {
          return writer.createRangeOn(cell);
        }), {
          backward: cellsToSelect.backward
        });
      });
    }
    /**
     * Returns the focus cell from the current selection.
     *
     * @returns {module:engine/model/element~Element}
     */

  }, {
    key: "getFocusCell",
    value: function getFocusCell() {
      var selection = this.editor.model.document.selection;

      var focusCellRange = _toConsumableArray(selection.getRanges()).pop();

      var element = focusCellRange.getContainedElement();

      if (element && element.is('element', 'tableCell')) {
        return element;
      }

      return null;
    }
    /**
     * Returns the anchor cell from the current selection.
     *
     * @returns {module:engine/model/element~Element} anchorCell
     */

  }, {
    key: "getAnchorCell",
    value: function getAnchorCell() {
      var selection = this.editor.model.document.selection;
      var anchorCellRange = first(selection.getRanges());
      var element = anchorCellRange.getContainedElement();

      if (element && element.is('element', 'tableCell')) {
        return element;
      }

      return null;
    }
    /**
     * Defines a selection converter which marks the selected cells with a specific class.
     *
     * The real DOM selection is put in the last cell. Since the order of ranges is dependent on whether the
     * selection is backward or not, the last cell will usually be close to the "focus" end of the selection
     * (a selection has anchor and focus).
     *
     * The real DOM selection is then hidden with CSS.
     *
     * @private
     */

  }, {
    key: "_defineSelectionConverter",
    value: function _defineSelectionConverter() {
      var _this3 = this;

      var editor = this.editor;
      var highlighted = new Set();
      editor.conversion.for('editingDowncast').add(function (dispatcher) {
        return dispatcher.on('selection', function (evt, data, conversionApi) {
          var viewWriter = conversionApi.writer;
          clearHighlightedTableCells(viewWriter);

          var selectedCells = _this3.getSelectedTableCells();

          if (!selectedCells) {
            return;
          }

          var _iterator = _createForOfIteratorHelper(selectedCells),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var tableCell = _step.value;
              var viewElement = conversionApi.mapper.toViewElement(tableCell);
              viewWriter.addClass('ck-editor__editable_selected', viewElement);
              highlighted.add(viewElement);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          var lastViewCell = conversionApi.mapper.toViewElement(selectedCells[selectedCells.length - 1]);
          viewWriter.setSelection(lastViewCell, 0);
        }, {
          priority: 'lowest'
        });
      });

      function clearHighlightedTableCells(writer) {
        var _iterator2 = _createForOfIteratorHelper(highlighted),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var previouslyHighlighted = _step2.value;
            writer.removeClass('ck-editor__editable_selected', previouslyHighlighted);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        highlighted.clear();
      }
    }
    /**
     * Creates a listener that reacts to changes in {@link #isEnabled} and, if the plugin was disabled,
     * it collapses the multi-cell selection to a regular selection placed inside a table cell.
     *
     * This listener helps features that disable the table selection plugin bring the selection
     * to a clear state they can work with (for instance, because they don't support multiple cell selection).
     */

  }, {
    key: "_enablePluginDisabling",
    value: function _enablePluginDisabling() {
      var _this4 = this;

      var editor = this.editor;
      this.on('change:isEnabled', function () {
        if (!_this4.isEnabled) {
          var selectedCells = _this4.getSelectedTableCells();

          if (!selectedCells) {
            return;
          }

          editor.model.change(function (writer) {
            var position = writer.createPositionAt(selectedCells[0], 0);
            var range = editor.model.schema.getNearestSelectionRange(position);
            writer.setSelection(range);
          });
        }
      });
    }
    /**
     * Overrides the default `model.deleteContent()` behavior over a selected table fragment.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} event
     * @param {Array.<*>} args Delete content method arguments.
     */

  }, {
    key: "_handleDeleteContent",
    value: function _handleDeleteContent(event, args) {
      var _args = _slicedToArray(args, 2),
          selection = _args[0],
          options = _args[1];

      var model = this.editor.model;
      var isBackward = !options || options.direction == 'backward';

      var selectedTableCells = _getSelectedTableCells(selection);

      if (!selectedTableCells.length) {
        return;
      }

      event.stop();
      model.change(function (writer) {
        var tableCellToSelect = selectedTableCells[isBackward ? selectedTableCells.length - 1 : 0];
        model.change(function (writer) {
          var _iterator3 = _createForOfIteratorHelper(selectedTableCells),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var tableCell = _step3.value;
              model.deleteContent(writer.createSelection(tableCell, 'in'));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        });
        var rangeToSelect = model.schema.getNearestSelectionRange(writer.createPositionAt(tableCellToSelect, 0)); // Note: we ignore the case where rangeToSelect may be null because deleteContent() will always (unless someone broke it)
        // create an empty paragraph to accommodate the selection.

        if (selection.is('documentSelection')) {
          writer.setSelection(rangeToSelect);
        } else {
          selection.setTo(rangeToSelect);
        }
      });
    }
    /**
     * Returns an array of table cells that should be selected based on the
     * given anchor cell and target (focus) cell.
     *
     * The cells are returned in a reverse direction if the selection is backward.
     *
     * @private
     * @param {module:engine/model/element~Element} anchorCell
     * @param {module:engine/model/element~Element} targetCell
     * @returns {Array.<module:engine/model/element~Element>}
     */

  }, {
    key: "_getCellsToSelect",
    value: function _getCellsToSelect(anchorCell, targetCell) {
      var tableUtils = this.editor.plugins.get('TableUtils');
      var startLocation = tableUtils.getCellLocation(anchorCell);
      var endLocation = tableUtils.getCellLocation(targetCell);
      var startRow = Math.min(startLocation.row, endLocation.row);
      var endRow = Math.max(startLocation.row, endLocation.row);
      var startColumn = Math.min(startLocation.column, endLocation.column);
      var endColumn = Math.max(startLocation.column, endLocation.column); // 2-dimensional array of the selected cells to ease flipping the order of cells for backward selections.

      var selectionMap = new Array(endRow - startRow + 1).fill(null).map(function () {
        return [];
      });
      var walkerOptions = {
        startRow: startRow,
        endRow: endRow,
        startColumn: startColumn,
        endColumn: endColumn
      };

      var _iterator4 = _createForOfIteratorHelper(new TableWalker(anchorCell.findAncestor('table'), walkerOptions)),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ref2 = _step4.value;
          var row = _ref2.row;
          var cell = _ref2.cell;
          selectionMap[row - startRow].push(cell);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var flipVertically = endLocation.row < startLocation.row;
      var flipHorizontally = endLocation.column < startLocation.column;

      if (flipVertically) {
        selectionMap.reverse();
      }

      if (flipHorizontally) {
        selectionMap.forEach(function (row) {
          return row.reverse();
        });
      }

      return {
        cells: selectionMap.flat(),
        backward: flipVertically || flipHorizontally
      };
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableSelection';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableUtils];
    }
  }]);

  return TableSelection;
}(Plugin);

export { TableSelection as default };